<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title></h1>
<div mat-dialog-content>
  <fa-icon [icon]="faExclamationTriangle" class="errorIcon"></fa-icon>
  <p *ngIf="type === 'system'">
    A system error has occurred: Please contact your system administrator
  </p>
  <p *ngIf="type !== 'system'">One or more items have failed to load</p>
  <span *ngIf="message" class="error">
    {{ message }}
    <br />
    {{ detail }}
  </span>
</div>
<div mat-dialog-actions></div>
